import { FileX2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
    title?: string;
    message?: string;
    className?: string;
}

export const EmptyState = ({
    title = "Nenhum resultado encontrado",
    message = "Tente ajustar seus filtros ou o período de busca.",
    className,
}: EmptyStateProps) => {
    return (
        <div
            className={cn(
                "flex flex-col items-center justify-center text-center py-12 px-6 bg-muted/50 dark:bg-muted/20 rounded-lg border-2 border-dashed border-border dark:border-border",
                className
            )}
        >
            <FileX2 className="h-12 w-12 text-muted-foreground/70" strokeWidth={1.5} />
            <h3 className="mt-4 text-lg font-semibold text-foreground">{title}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{message}</p>
        </div>
    );
};
